export const linksConfig = {
  inventory: "/inventory",
  electrical: "https://www.bmw.co.il/he/electric-cars.html",
  model: "/",
  service: "product",
  models: "/",
  contact: "/contact",
}
